import { render, staticRenderFns } from "./ReserveResourceDb.vue?vue&type=template&id=f60c3a70"
import script from "./ReserveResourceDb.ts?vue&type=script&lang=ts&external"
export * from "./ReserveResourceDb.ts?vue&type=script&lang=ts&external"
import style0 from "./ReserveResourceDb.vue?vue&type=style&index=0&id=f60c3a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports